import { inject } from '@angular/core';

import {
  type TellentAppKindParam,
  type TellentAppRouteID,
  type TellentPageConfig,
  ORG_GUID,
} from '@core/tellent-types';
import { injectTellentAppUrlBuilder } from '@core/tellent-util';

export function injectAssistantEntityUrl() {
  const build = injectTellentAppUrlBuilder();
  const orgGuid = inject(ORG_GUID, { optional: true });

  return (appKind: TellentAppKindParam, page: TellentPageConfig<TellentAppRouteID>): string =>
    build(appKind, page, orgGuid ?? undefined);
}
